export { default as DocumentOutlineIcon } from './DocumentOutlineIcon';
